import script from "./TopBackgroundComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBackgroundComponent.vue?vue&type=script&setup=true&lang=js"

import "./TopBackgroundComponent.vue?vue&type=style&index=0&id=340c18c7&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340c18c7"]])

export default __exports__